import React from 'react'

import { Flex, Text } from 'front-end/src/components'
import { ActivityTopicDataFragment } from '../ActivityHistory.codegen'
import { ActivityHistoryTypeEnum } from '../activityHistoryTypes'
import {
  getActivityTopicLink,
  getActivityTopicName
} from '../activityHistoryUtils'
import ActivityNameInfo from './ActivityNameInfo'
import ActivityHistoryResourceIcon from './ActivityHistoryResourceIcon'

type ActivityHistoryResourceNameProps = Pick<
  ActivityTopicDataFragment,
  'originSection' | 'topicVersion'
> & { topicId: number; isArchived?: boolean }

const ActivityHistoryResourceName = ({
  topicVersion,
  originSection,
  topicId,
  isArchived
}: ActivityHistoryResourceNameProps) => {
  return (
    <ActivityNameInfo
      typename={ActivityHistoryTypeEnum.TopicEnrolmentModelAsStudent}
      title={topicVersion?.title || ''}
      linkUrl={getActivityTopicLink(originSection, topicId)}
      isArchived={isArchived}
    >
      {originSection && (
        <Flex>
          <ActivityHistoryResourceIcon sourceType={originSection.__typename} />
          <Text lineHeight="21px" noOfLines={2}>
            {getActivityTopicName(originSection)}
          </Text>
        </Flex>
      )}
    </ActivityNameInfo>
  )
}

export default ActivityHistoryResourceName
